import type { Component } from 'vue'

import type { ContentItemLinkDetails, ContentItemStatusActionEnum } from '../../../types'

export const DETAILS_TOOLTIP_Z_INDEX = 10001

export type ViewMode = 'admin' | 'advertiser'
export type ContentItem = ContentItemLinkDetails['contentItems'][number]
export type MetricRow = {
  label: string
  value: string | number
  tooltip?: { title?: string; description: string }
}
export type FooterButtonAction = ContentItemStatusActionEnum | 'download'

export type ContentItemDownloadRequest = {
  contentItemId: string
  assetId?: string
  url: string
}
export type ActionButton = {
  action: FooterButtonAction
  hotkey: string
  icon: Component | null
  label: string
  isLoading: boolean
  cssClass: string
  adminOnly: boolean
}
